import { STRAVA_AUTOMATION_STAGE_STATUSES } from './stravaAutomationStageStatuses'
import * as stravaUrls from './stravaUrls'
import * as enums from '../../utils/enums'
import { StageDef } from '../automationMachineInterfaces'
import {
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
} from '../recommendationCardDisplayUtils'

// Settings properties
const getCurrentValueFn = () => () => null

const getIsFulfilledFn = () => () => false

const getCantUndoFn = () => () => true

const getIsDisabledFn = () => defaultIsDisabledFn

const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

// Setup gather stage definitions

enum StageKey {
  GATHER_SETTING_PAST_ACTIVITIES = 'GATHER_SETTING_PAST_ACTIVITIES',
  UPDATE_SETTING_PAST_ACTIVITIES = 'UPDATE_SETTING_PAST_ACTIVITIES',
}

async function updatePastActivities() {
  const metaElement = document.getElementsByName(
    'csrf-token',
  )[0] as HTMLMetaElement

  const dateStr = new Date().toISOString().replace(/\.\d{3}Z$/, '+00:00')

  const payload = {
    updates: {
      visibility: 'followers_only',
    },
  }

  const response = await fetch(
    `https://www.strava.com/activity_bulk_updates?t=${dateStr}`,
    {
      method: 'POST',
      headers: {
        Accept: 'text/javascript',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': metaElement.content,
        'Content-Type': 'application/json;charset=UTF-8',
      },
      body: JSON.stringify(payload),
    },
  )

  if (response.status !== 202) {
    throw new Error(
      `Web request to update ${JSON.stringify(payload)} not successful`,
    )
  }
}

const gatherStageDefs: StageDef[] = [
  {
    type: enums.StageType.ACTION,
    key: StageKey.GATHER_SETTING_PAST_ACTIVITIES,
    status: STRAVA_AUTOMATION_STAGE_STATUSES.UPDATING_SETTINGS,
    url: stravaUrls.privacySettingsUrl,
    action: async (machineContext, userContext) => {
      const { updateStoredInitialValues } = userContext

      await updateStoredInitialValues(
        {},
        enums.StravaRecommendationKey.STRAVA_PAST_ACTIVITIES,
      )
    },
  },
]

const updateStageDefs: StageDef[] = [
  {
    type: enums.StageType.ACTION,
    key: StageKey.UPDATE_SETTING_PAST_ACTIVITIES,
    status: STRAVA_AUTOMATION_STAGE_STATUSES.UPDATING_SETTINGS,
    url: stravaUrls.privacySettingsUrl,
    action: async () => {
      await updatePastActivities()
    },
  },
]

const undoStageDefs: StageDef[] = []

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
